import * as React from "react";
import * as blogStyles from "./blog.module.css";
import SectionTitle from "../Layout/Section/Title";
import Link from "../UI/Link";
import ArticleCard from "../Article/Card";
import Section from "../Layout/Section";

const Blog = ({articles}) => {
    return (
        <Section>
            <div className={blogStyles.blog}>
                <div className={blogStyles.blog__header}>
                    <SectionTitle>Блог</SectionTitle>
                    <Link to="/blog" withArrow className={blogStyles.blog__link}>
                        Все статьи
                    </Link>
                </div>
                <div className={blogStyles.blog__articles}>
                    {articles.map((article, idx) => {
                        const articleData = {
                            title: article.title,
                            description: article.description,
                            date: new Date(article.publishDate),
                            readingTime: article.readingTime,
                            url: `/blog/${article.slug}`,
                            tag: article.tags &&
                                article.tags[0] && {
                                    title: article.tags[0].title,
                                    url: `/blog?tags=${article.tags[0].slug}`,
                                },
                        };

                        return <ArticleCard {...articleData} key={idx} />;
                    })}
                </div>
            </div>
        </Section>
    );
};

export default Blog;
